<div class="form-check {{ props.cssClass }}">
  <input
    type="checkbox"
    class="form-check-input"
    [id]="field.key"
    [formControl]="formControl"
    [formlyAttributes]="field"
    [class.is-invalid]="hasValidation && invalid"
    [class.is-valid]="hasValidation && valid"
    (change)="change($event)"
  />
  <label class="form-check-label" [for]="field.key">{{ props.label }}</label>
</div>
